module.exports = __webpack_public_path__ + "static/media/features-ic-04.809430a6.svg";